module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-left-panel-1-5658efe2526ef34f1e88861efef9e93b.svg";